import {
  GetTimeSetQueryParamsType,
  GetTimeSetQueryResponseType,
} from '@/common/queries/getTimeSet/getTimeSetQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const getTimeSetFunction = (
  params: GetTimeSetQueryParamsType,
): Promise<GetTimeSetQueryResponseType> => {
  return fetchApi.get(`/actions/${params.id}/time_set/`);
};
